export default "__VITE_ASSET__bc100109__"